require('./datatables')

jQuery.fn.extend({
  hideAndDisable() {
    this.each(() => {
      this.hide()
      this.find('input').prop('disabled', true)
    })
  },
  showAndEnable() {
    this.each(() => {
      this.show()
      this.find('input').prop('disabled', false)
    })
  }
});

(function($){
  $('#sidenav-mobile').sidenav({
    draggable: true})

  $('.modal').modal()

  $('select').formSelect()

  $('.dropdown-trigger').dropdown()

  $('.datepicker').datepicker({
    autoClose: true,
    format: 'dd/mm/yyyy',
    maxDate: new Date(),
    i18n: {
      cancel: 'Cancelar',
      months: ['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre'],
      monthsShort: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul', 'Ago', 'Sep', 'Oct', 'Nov', 'Dic'],
      weekdays: ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'],
      weekdaysShort: ['Dom', 'Lun', 'Mar', 'Mie', 'Jue', 'Vie', 'Sáb'],
      weekdaysAbbrev: ['D', 'L', 'M', 'M', 'J', 'V', 'S'],
    }
  })

  if ($('#advanced_search').length > 0) {
    const activateYear = function() {
      $('.q_terms_year').showAndEnable()
      $('.q_ranges_year_lte').hideAndDisable()
      $('.q_ranges_year_gte').hideAndDisable()
      $('#exact_year').hide()
      $('#between_years').show()
    }

    const activateBetweenYears = function() {
      $('.q_terms_year').hideAndDisable()
      $('.q_ranges_year_lte').showAndEnable()
      $('.q_ranges_year_gte').showAndEnable()
      $('#exact_year').show()
      $('#between_years').hide()
    }

    $('#exact_year').click(function(e) {
      e.preventDefault()
      activateYear()
    })

    $('#between_years').click(function(e){
      e.preventDefault()
      activateBetweenYears()
    })

    if ($('#q_ranges_year_lte').val() || $('#q_ranges_year_gte').val()) {
      activateBetweenYears()
    } else {
      activateYear()
    }
  }

  $('i#close-card').css('cursor', 'pointer')
  $('i#close-card').click(function() { $(this).parent('.card-panel').fadeOut('slow') })

  $('#covid19-modal').modal()
  $('#covid19-modal').modal('open')

  $('#covid19-carousel').carousel({
    fullWidth: true,
    indicators: true
  })

  $('.clickable-row').on('click', e => {
    e.preventDefault()

    window.open($(e.currentTarget).data('href'), '_blank')
  })

  $('#covid19-table').DataTable({
    aaSorting: [],
    pageLength: 6,
    lengthChange: false,
    dom: 'ftip',
    language: {
      "sProcessing": "Procesando...",
      "sLengthMenu":     "Mostrar _MENU_ registros",
      "sZeroRecords": "No se encontraron resultados",
      "sEmptyTable": "Ningún dato disponible en esta tabla =(",
      // "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
      "sInfo": "Página _PAGE_ de _PAGES_ (_TOTAL_ resultados)",
      "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
      "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
      "sInfoPostFix": "",
      "sSearch": "Búsqueda rápida",
      "sUrl": "",
      "sInfoThousands": ",",
      "sLoadingRecords": "Cargando...",
      "oPaginate": {
        "sFirst": "Primera",
        "sLast": "Última",
        "sNext": "Siguiente",
        "sPrevious": "Anterior"
      },
      "oAria": {
        "sSortAscending": ": Activar para ordenar la columna de manera ascendente",
        "sSortDescending": ": Activar para ordenar la columna de manera descendente"
      },
      "buttons": {
        "copy": "Copiar",
        "colvis": "Visibilidad"
      }
    }
  })
})(jQuery)